import { render, staticRenderFns } from "./AccountTypeChips.vue?vue&type=template&id=fd7c601e"
import script from "./AccountTypeChips.vue?vue&type=script&lang=js"
export * from "./AccountTypeChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports